import { toMapFn } from "~/common/utils/reducers";

function addProductToRecommendedForSession(designation: string) {
  if (!isProductRecommendedForSession(designation)) {
    addRecommendedProduct(designation);
    saveRecommendedProducts();
  }
}

function isProductRecommendedForSession(designation: string) {
  return recommendedProducts[designation] ?? false;
}

let recommendedProducts: Dict<boolean> = {};

function addRecommendedProduct(designation: string) {
  recommendedProducts[designation] = true;
}

function saveRecommendedProducts() {
  window.sessionStorage.setItem("recommendedProductsList", JSON.stringify(Object.keys(recommendedProducts)));
}

function loadRecommendedProducts() {
  const recommendedProductsList: string[] = JSON.parse(
    window.sessionStorage.getItem("recommendedProductsList") ?? "[]",
  );
  recommendedProducts = toMapFn(
    recommendedProductsList,
    (item) => item,
    () => true,
  );
}

loadRecommendedProducts();

export const RecommendedProductsService = {
  isProductRecommendedForSession,
  addProductToRecommendedForSession,
};
